import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Headers } from "@angular/http";
import { ServiceConfig } from "./service-config";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class LogSeedingService {
  private host = ServiceConfig.host;
  public baseUrl = this.host + "/api/log-seeding/";
  // public baseUrl = 'http://localhost/api/projects/';
  public data: any;
  public headers: Headers;
  public options: {};

  constructor(private http: HttpClient, private router: Router) {
    // console.log(this.data.token);
    this.headers = new Headers({
      "Content-Type": "application/json",
    });
    this.options = { headers: this.headers };
  }

  public getAll(body) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + "?token=" + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
  public createLog(params: any) {
    const url = "";
    return this.http.post<any>(url, params);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/log-seeding.service.ts